<kendo-dropdownlist
  [data]="data()"
  (focusin)="focus()"
  (focusout)="blur()"
  (open)="focus(); onOpened()"
  (close)="blur()"
  (closed)="closed.emit($event)"
  [formControl]="$any(_control)"
  [filterable]="filterable()"
  [value]="value()"
  [textField]="textField()"
  [valueField]="valueField()"
  (valueChange)="valueChange.emit($event)"
  (filterChange)="filterChange.emit($event)"
  [valuePrimitive]="valuePrimitive()"
  [popupSettings]="popupSettings()"
  [adaptiveMode]="adaptiveMode()"
  [listHeight]="listHeight()"
>
  @if (valueTemplate()) {
    <ng-template kendoDropDownListValueTemplate let-item>
      <ng-container [ngTemplateOutlet]="valueTemplate()" [ngTemplateOutletContext]="{ $implicit: item }" />
    </ng-template>
  }

  @if (itemTemplate()) {
    <ng-template kendoDropDownListItemTemplate let-item>
      <ng-container [ngTemplateOutlet]="itemTemplate()" [ngTemplateOutletContext]="{ $implicit: item }" />
    </ng-template>
  }

  @if (fixedGroupTemplate()) {
    @for (x of fixedGroupTemplate(); track x) {
      <ng-template kendoDropDownListFixedGroupTemplate let-group>
        <ng-container [ngTemplateOutlet]="x" [ngTemplateOutletContext]="{ $implicit: group }" />
      </ng-template>
    }
  }

  @if (groupTemplate()) {
    <ng-template kendoDropDownListGroupTemplate let-group>
      <ng-container [ngTemplateOutlet]="groupTemplate()" [ngTemplateOutletContext]="{ $implicit: group }" />
    </ng-template>
  }

  @if (footerTemplate()) {
    <ng-template kendoDropDownListFooterTemplate let-group>
      <ng-container [ngTemplateOutlet]="footerTemplate()" [ngTemplateOutletContext]="{ $implicit: group }" />
    </ng-template>
  }
</kendo-dropdownlist>
